import * as React from "react";

const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8.992}
    height={8.992}
    {...props}
  >
    <path
      data-name="Path 307"
      d="M88.5 14a4.5 4.5 0 1 0 4.5 4.5 4.5 4.5 0 0 0-4.5-4.5zm2.489 4.752h-2.237v2.234a.255.255 0 0 1-.256.256.259.259 0 0 1-.256-.256v-2.234h-2.233a.259.259 0 0 1-.256-.256.255.255 0 0 1 .256-.256h2.234v-2.233a.256.256 0 1 1 .511 0v2.234h2.234a.255.255 0 0 1 .256.256.267.267 0 0 1-.256.256z"
      transform="translate(-84 -14)"
      style={{
        fill: "#00446e",
      }}
    />
  </svg>
);

export default SvgComponent;
